<template>
  <div class="body-container pt-30">
    <div class="container-fluid minHeight-120">
      <router-link to="printPDF" class="btn btn-default float-right fw-600"
        >返回報表列印</router-link
      >
      <div class="font-16 mb-40">
        <span class="pdfTitle">尋保圖(個人總覽)</span>
        <span @click="instructions" class="text-orange btn">
          <i class="icon-attach i-20 textTop"></i>
          <u>使用說明</u>
        </span>
      </div>
      <div class="text-black mb-30">
        <strong class="font-24">步驟1/2:選擇報表</strong>
      </div>

      <!-- ------------------------------------------------可選報表------------------------------------------------ -->
      <div class="text-green mb-30">
        <strong class="font-20">可選報表</strong>
        <button
          type="button"
          class="btn btn-default btn-sm baseLine"
          @click="selectAll(true)"
          v-show="!isSelectPdf"
        >
          選取所有報表
        </button>
        <button
          v-show="isSelectPdf"
          type="button"
          class="btn btn-default btn-sm baseLine"
          @click="selectAll(false)"
        >
          清空所有報表
        </button>
        <button
          type="button"
          class="btn btn-default btn-sm baseLine"
          @click="selectCommonlyUsed()"
        >
          選取所有常用報表
        </button>
      </div>
      <div v-for="(item, index) in familyInfoList" :key="index">
        <div class="text-black mb-15 form-inline">
          <span :class="`checkbox m-0`">
            <input
              v-model="item.theadAll"
              @click="changeInput(item)"
              type="checkbox"
              :value="item.reportType"
              :id="`thead${index}`"
            />
            <label :for="`thead${index}`"></label>
          </span>
          <strong class="font-16">{{ item.reportTitle }}</strong>
          <span
            @click="openPdfInfo(item.reportTitle, item.reportType)"
            class="text-green text-underline ml-10 mr-14"
            >說明</span
          >
          <template v-if="item.theadAll">
            <button
              type="button"
              class="btn btn-default btn-sm ml-14"
              @click="changeInputTF(item, true)"
              v-show="!item.theadAllS"
            >
              選取所有成員
            </button>
            <button
              type="button"
              class="btn btn-default btn-sm ml-14"
              @click="changeInputTF(item, false)"
              v-show="item.theadAllS"
            >
              清空所有成員
            </button>
          </template>
          <a
            role="button"
            :class="`btn btn-default btn-sm btn-common mr-20 ${
              item.commonlyUsed ? 'btn-common-active' : 'btn-common'
            }`"
            @click="setCommonlyUsed(item)"
          >
            常用
          </a>
        </div>
        <div class="ml-27 row" v-if="item.theadAll">
          <div
            class="col-2 pr-1 pl-1 mb-2"
            style="min-width: 150px"
            v-for="(itemI, indexI) in item.familyResultFilter"
            :key="indexI"
          >
            <div
              :style="itemI.chkFocus ? 'border: red solid 1px;' : ''"
              :class="`checkboxMv checkbox-inline  ${
                familyInfoList[index].familyResultFilter[indexI]['check']
                  ? 'activeInput'
                  : 'nactiveInput'
              }`"
            >
              <input
                v-model="
                  familyInfoList[index].familyResultFilter[indexI]['check']
                "
                :value="itemI.csidno"
                @click="checkNonSelected(item, indexI)"
                type="checkbox"
                :id="`customer${index}-${indexI}`"
                :ref="`customer${index}-${indexI}`"
              />
              <label :for="`customer${index}-${indexI}`" class="ml-3">
                <span>{{ truncate(itemI.name, 12) }}</span>
                <!-- <span>{{ familyInfoList[index].familyResultFilter[indexI].check}}{{index}}{{indexI}}</span> -->
              </label>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <!-- ------------------------------------------------可選報表------------------------------------------------ -->
      <!-- ----------------------------------------------報表列印順序----------------------------------------------- -->
      <div>
        <div class="text-green mt-5 font-20">
          <strong>拖曳調整報表列印順序</strong>
          <button
            type="button"
            @click="sortDragItem()"
            class="btn btn-default btn-sm"
            style="vertical-align: middle"
          >
            回復預設排序
          </button>
        </div>
        <div v-if="familyInfoListDrag.length > 0" style="width: 50%">
          <draggable
            :list="familyInfoListDrag"
            :disabled="!enabled"
            v-bind="dragOptions"
            ghost-class="ghost"
            :move="checkMove"
            @start="dragging = true"
            @end="dragging = false"
          >
            <div
              class="d-flex flex-row"
              v-for="(element, index) in familyInfoListDrag"
              :key="element.name"
            >
              <div class="pdf-index">{{ index + 1 }}</div>
              <div class="mr-auto pdfBtn">
                <i class="fas fa-arrows-alt text-gray mr-2"></i>
                {{ element.reportTitle }}
              </div>
            </div>
          </draggable>
        </div>
        <div v-else class="noPDFListData mt-4">尚未選取任何報表或列印對象</div>
      </div>
      <!-- ----------------------------------------------報表列印順序---------------------------------------------- -->
      <!-- ----------------------------------------------報表顯示設定---------------------------------------------- -->
      <div class="mb-60">
        <div class="text-green mt-5 mb-20 font-20">
          <strong>報表顯示設定</strong>
        </div>
        <div class="mt-3">
          1. 保戶為原住民時，是否顯示原住民姓名欄位顯示說明?
        </div>

        <div class="d-flex">
          <div class="radio radio-inline">
            <input type="radio" id="radioY" value="Y" v-model="isIndigenous" />
            <label for="radioY">是</label>
          </div>
          <div class="radio radio-inline">
            <input type="radio" id="radioN" value="N" v-model="isIndigenous" />
            <label for="radioN">否</label>
          </div>
        </div>
      </div>
      <!-- ----------------------------------------------報表顯示設定---------------------------------------------- -->
      <div class="text-black mb-30 font-24">
        <strong>步驟2/2:設定封面資訊</strong>
      </div>
      <!-- ----------------------------------------------封面樣式---------------------------------------------- -->
      <div class="mb-30">
        <div class="text-green mb-20 font-20">
          <strong>封面樣式</strong>
        </div>
        <div class="d-flex justify-content-between col-5 pl-0">
          <div class="radio radio-inline">
            <input type="radio" id="radioCoverY" value="Y" v-model="isCover" />
            <label for="radioCoverY">封面1</label>
          </div>
          <div class="radio radio-inline">
            <input type="radio" id="radioCoverN" value="N" v-model="isCover" />
            <label for="radioCoverN">不列印封面</label>
          </div>
        </div>
        <img
          style="width: 25%; height: 25%"
          class="img-responsive fit-image"
          :src="`${BaseUrl}assets/MV_H00001_cover_background.png`"
        />
      </div>
      <!-- ----------------------------------------------封面樣式---------------------------------------------- -->
      <!-- ----------------------------------------------服務人員資訊---------------------------------------------- -->
      <div>
        <template>
          <div v-show="!serverEdit">
            <div
              class="text-green font-20 d-flex align-items-center"
              style="margin-bottom: 12px"
            >
              <span class="custModifyAgent">服務人員資訊</span>
              <button
                type="button"
                style="vertical-align: middle"
                class="btn btn-default btn-sm"
                @click="serverEdit = true"
              >
                修改
              </button>
            </div>
            <div
              class="text-black mt-2 mb-3 ml-2 d-flex align-items-center"
              style="height: 40px"
            >
              <span class="custAgentTitle">保險顧問</span>
              <span class="ml-3 custAgentContent">{{
                agentName ? agentName : "--"
              }}</span>
            </div>
            <div
              class="text-black ml-2 d-flex"
              :class="{ 'section-loading': loading_1 }"
            >
              <span class="custAgentTitle" style="line-height: 40px"
                >手機&emsp;&emsp;</span
              >
              <span>
                <span class="ml-3 custAgentContent" style="line-height: 40px"
                  >{{ agentMobile ? agentMobile : " " | mobileFormat }}
                </span>
                <div>&nbsp;</div>
              </span>
            </div>
          </div>
        </template>
        <template>
          <!-- ----------------------------------------------修改服務人員個人資訊(家庭)------------------------------- -->
          <EditAgentInfoFamily-Modal
            v-show="serverEdit"
            @close="serverEdit = false"
            @setAgentData="setAgentData"
          />
        </template>
      </div>
      <!-- ----------------------------------------------服務人員資訊---------------------------------------------- -->
    </div>
    <!-- ----------------------------------------------列印PDF---------------------------------------------- -->
    <fixed-bottom v-show="!isScroll">
      <template slot="@function">
        <form
          style="display: none"
          method="post"
          ref="form"
          target="_blank"
          :action="`${API_BASEURL}/servlet/HttpDispatcher/DOWNLOAD_FILE_API2/download?fileNo=${fileNo}`"
        >
          <input
            type="submit"
            formtarget="_blank"
            :value="`${API_BASEURL}/servlet/HttpDispatcher/DOWNLOAD_FILE_API2/download?fileNo=${fileNo}`"
          />
        </form>
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-primary mr-0"
            v-show="!isIpad()"
            @click="showPDF(true)"
            type="button"
          >
            下載PDF
          </button>
          <button
            class="btn btn-primary mr-0"
            @click="showPDF(false)"
            type="button"
          >
            開啟PDF
          </button>
          <button
            :disabled="!$checkEdit(UserInfo)"
            type="button"
            class="btn btn-primary mr-0"
            @click="openEmail()"
          >
            發送EMAIL
          </button>
        </div>
      </template>
    </fixed-bottom>
    <!-- ----------------------------------------------列印pop-up---------------------------------------------- -->
    <mv-info :open="showOpenPdf" @close="printPDF()">
      <div class="text font-20" slot="content">
        <div style="color: red">
          <span style="font-weight: bold">優化後新系統的保障數值更為精確，</span
          >建議您提供新的報表給客戶參考。
        </div>
      </div>
    </mv-info>
    <!-- ----------------------------------------------列印PDF---------------------------------------------- -->
    <!-- ----------------------------------------------發送email---------------------------------------------- -->
    <SendEmail-Modal
      :open="sendEmailModalOpen"
      @close="panelClose('sendEmailModalOpen')"
      @doSendEmail="doSendEmail"
    />

    <!-- 打開遮罩 -->
    <mv-mask :open="mvMaskOpen" />

    <mv-pdf-info
      :title="pdfModalTitle"
      :type="pdfModalType"
      :open="mvPdfInfoOpen"
      @close="panelClose('mvPdfInfoOpen')"
    >
      <!-- 1.尋保攻略 -->
      <ol v-if="pdfModalType === '90'" slot="content" class="pb-5">
        <li>以「被保人」角度彙整。</li>
        <li>
          呈現該被保人當年度權益，並以十大保障分類各重要給付項目代表計算保障有效期間。
        </li>
        <li>十大保障分類的代表項目請參照「使用說明」。</li>
      </ol>
      <!-- 2.尋保地圖 -->
      <ol v-if="pdfModalType === '91'" slot="content" class="pb-5">
        <li>以「被保人」角度彙整。</li>
        <li>以十大保障分類各重要給付項目代表計算，呈現該被保人的保障缺口。</li>
        <li>十大保障分類的代表項目請參照「使用說明」。</li>
      </ol>
      <!-- 3.尋保攻略 -->
      <ol v-if="pdfModalType === '92'" slot="content" class="pb-5">
        <li>以「被保人」角度彙整。</li>
        <li>呈現該要保人於國泰及同業保單逐月應繳保費資訊。</li>
        <li>請先自行檢視同業保單之要保人資訊是否有正確建檔。</li>
      </ol>
      <!-- 4.尋保攻略 -->
      <ol v-if="pdfModalType === '93'" slot="content" class="pb-5">
        <li>以「被保人」角度彙整。</li>
        <li>呈現該被保人未來每一年「年金/滿期金」或「身故給付金額」的趨勢。</li>
      </ol>
    </mv-pdf-info>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import moment from "moment";
import Avatar from "@/desktop/components/Avatar";
import mvMask from "@/desktop/views/mv/components/mvMask";
import { pdfPrintMixin } from "@/desktop/views/mv/pdfPrint/pdfPrintMixin";
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import WarningModal from "@/desktop/components/WarningModal";
import NewGroup from "@/desktop/components/NewGroup";
import AddGroupModal from "@/desktop/components/AddGroupModal";
import SendEmailModal from "@/desktop/views/mv/components/SendEmailModal";
import FixedBottom from "@/desktop/views/mv/components/modal/fixedBotton";
import { getAllFamily } from "@/service";
import { getAgntInfo } from "@/service";
import HardwordMixins from "@/mixins/Hardword"; // for 難字更新
import { mapGetters } from "vuex";
import EditAgentInfoFamilyModal from "@/desktop/views/mv/components/EditAgentInfoFamilyModal";
import {
  getPDFFile,
  getPDFFileForMail,
  getPdfFileForReport,
  getCommonlyUsedReport,
  insertCommonlyUsedReport,
  deleteCommonlyUsedReport,
} from "@/service";
import { log } from "util";
import mvPdfInfo from "@/desktop/views/mv/components/mvPdfInfo";
import mvInfo from "@/desktop/views/mv/components/mvInfo";

export default {
  name: "TreasureFind",
  mixins: [commonMixin, HardwordMixins, pdfPrintMixin],
  data() {
    return {
      serverEdit: false,
      dragging: false,
      enabled: true,
      //是否滾動
      isScroll: false,
      //全選
      theadAll: false,
      //業務員ID
      agidno: this.$store.state.userInfo.id,
      //業務員名字
      agentName: "",
      //手機
      agentMobile: "",
      //過濾有勾選
      familyResultFilter: this.$store.state.familyResultFilter,
      //全部報表
      familyInfoList: [],
      //全部報表Drag
      familyInfoListDrag: [],
      //是否為原住民
      isIndigenous: "N",
      //是否列印封面
      isCover: "N",
      remoteDataMessage: "資料讀取中，請稍候...",
      sendEmailModalOpen: false,
      editAgentInfoFindInsModalOpen: false,
      loading_1: false,
      mvMaskOpen: false,
      //控制外層選取報表
      isSelectPdf: false,
      //報表說明開關
      mvPdfInfoOpen: false,
      //報表說明標題
      pdfModalTitle: "",
      //報表說明種類
      pdfModalType: "",
      //要跳focus的位置
      focusPosition: "",
      //PDF 彈窗
      showOpenPdf: false,
      isDownload: false,
      fileNo: "",
      API_BASEURL: "",
    };
  },
  components: {
    draggable,
    Avatar,
    SendEmailModal,
    mvMask,
    FixedBottom,
    mvPdfInfo,
    mvInfo,
    EditAgentInfoFamilyModal,
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserInfo"]),
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  watch: {
    familyInfoList: {
      deep: true,
      handler(newValue, oldValue) {
        let selectCheck = 0;
        for (let i = 0; i < this.familyInfoList.length; i++) {
          let chk = 0;
          let isAll = this.familyInfoList[i].isAll;
          for (
            let j = 0;
            j < this.familyInfoList[i].familyResultFilter.length;
            j++
          ) {
            if (this.familyInfoList[i].familyResultFilter[j].check == true) {
              chk++;
              selectCheck++;
            }
          }
          if (chk == this.familyInfoList[i].familyResultFilter.length) {
            this.familyInfoList[i].theadAll = true;
            this.familyInfoList[i].theadAllS = true;
          } else if (chk === 0) {
            if (this.familyInfoList[i].familyResultFilter.length == 1) {
              // this.familyInfoList[i].theadAll = false;
            }
            this.familyInfoList[i].theadAllS = false;
          } else {
            this.familyInfoList[i].theadAllS = true;
          }
          if (
            (chk > 0 || isAll) &&
            !this.familyInfoListDragInclude(this.familyInfoList[i].reportTitle)
          ) {
            this.familyInfoListDrag.push(this.familyInfoList[i]);
            //整理
            // this.sortDragItem();
          } else if (
            chk == 0 &&
            this.familyInfoListDragInclude(this.familyInfoList[i].reportTitle)
          ) {
            this.familyInfoListDragInclude(
              this.familyInfoList[i].reportTitle,
              "Y"
            );
            //整理
            // this.sortDragItem();
          }
        }
        if (selectCheck > 0) {
          this.isSelectPdf = true;
        } else {
          this.isSelectPdf = false;
        }
      },
    },
  },
  methods: {
    ...mapActions([
      "updateUserItems",
      "setPageLock",
      "updateFamilyResultFilter",
    ]),
    moment,
    instructions() {
      this.panelOpen("mvMaskOpen");
      let sendData = this.getSendData();
      sendData.isSendMail = false;
      // 若為webview開啟則不開新視窗
      let newWindow = this.isWebView() ? window : this.openNewWindow();
      getPdfFileForReport(this.agidno, "PersonalSummaryGuide.pdf").then(
        (result) => {
          if (result.byteLength <= 120) {
            if (!this.isWebView()) {
              newWindow.close();
            }
            this.panelClose("mvMaskOpen");
            setTimeout(() => alert("報表查無資料"));
            return;
          }
          let file = new Blob([result], { type: "application/pdf" });
          this.sendPdfDataToApp(file, "尋保圖-使用說明");
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file, "尋保圖-使用說明.pdf");
          } else {
            newWindow.location = URL.createObjectURL(file);
          }
          this.panelClose("mvMaskOpen");
        }
      );
    },
    openPdfInfo(title, type) {
      this.pdfModalTitle = title;
      this.pdfModalType = type;
      this.panelOpen("mvPdfInfoOpen");
    },
    selectAll(selectType) {
      this.familyInfoList.forEach((element) => {
        element.theadAll = selectType;
        element.familyResultFilter.forEach(
          (elementI) => (elementI.check = selectType)
        );
      });
    },
    setCommonlyUsed(item) {
      let report = "01"; // 00：家庭保單健檢規劃書 01：尋保圖（個人總覽）02：321+1保藏圖
      if (item.commonlyUsed) {
        deleteCommonlyUsedReport(this.agidno, report, item.reportType).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              item.commonlyUsed = false;
              this.sortCommonlyUsed();
            }
          }
        );
      } else {
        if (
          this.familyInfoList.filter((item) => {
            return item.commonlyUsed == true;
          }).length >= 5
        ) {
          this.$toast.info({ title: "標記「常用報表」上限為5張報表" });
        } else {
          insertCommonlyUsedReport(this.agidno, report, item.reportType).then(
            (result) => {
              if (result.header && result.header.status == "200") {
                item.commonlyUsed = true;
                this.sortCommonlyUsed();
              }
            }
          );
        }
      }
    },
    selectCommonlyUsed() {
      this.familyInfoList.forEach((element) => {
        if (element.commonlyUsed) {
          element.theadAll = true;
          element.familyResultFilter.forEach(
            (elementI) => (elementI.check = true)
          );
        }
      });
    },
    len(str) {
      return str.replace(/[^\x00-\xff]/g, "xx").length;
    },
    sub(str, n) {
      let l = 0;
      for (let i = 0; i < str.length; i++) {
        if (str[i].match(/[^\x00-\xff]/g)) {
          l += 2;
        } else {
          l++;
        }
        if (l >= n) {
          return str.substr(0, i + 1);
        }
      }
    },
    truncate(str, n) {
      if (str) {
        return this.len(str) > n ? this.sub(str, n) + "..." : str;
      } else {
        return "";
      }
    },
    checkPDF() {
      let chkAll = false;
      let chkPosition = false;

      for (let i = 0; i < this.familyInfoList.length; i++) {
        let theadAll = this.familyInfoList[i].theadAll;
        let chkPrint = 0;
        this.familyInfoList[i].familyResultFilter.forEach((item) => {
          if (theadAll && !item.check) {
            chkPrint++;
          }
        });
        if (chkPrint == this.familyInfoList[i].familyResultFilter.length) {
          this.familyInfoList[i].familyResultFilter = this.familyInfoList[
            i
          ].familyResultFilter.map((item) => {
            item.chkFocus = true;
            if (!chkPosition) {
              this.focusPosition = i;
              chkPosition = true;
            }
            chkAll = true;
            return item;
          });
        } else {
          this.familyInfoList[i].familyResultFilter.forEach((item) => {
            item.chkFocus = false;
          });
        }
      }
      if (
        this.focusPosition != null &&
        Number.isInteger(this.focusPosition) &&
        chkAll
      ) {
        const ref = `customer${this.focusPosition}-0`;
        this.$refs[ref][0].focus();
        this.$toast.info({ title: "請確認列印對象" });
        if (this.showOpenPdf) {
          this.panelClose("showOpenPdf");
        }
        return false;
      }
      return true;
    },
    showPDF(isDownload) {
      let chkNoPDFPrint = false;
      this.isDownload = isDownload;
      for (let i = 0; i < this.familyInfoList.length; i++) {
        let theadAll = this.familyInfoList[i].theadAll;
        if (theadAll) {
          chkNoPDFPrint = true;
        }
      }
      if (!chkNoPDFPrint) {
        this.$toast.info({ title: "請先勾選報表" });
        return false;
      }
      if (!this.checkPDF()) return;
      this.printPDF();
    },
    printPDF() {
      this.serverEdit = false;
      this.panelClose("showOpenPdf");
      this.panelOpen("mvMaskOpen");
      let sendData = this.getSendData();
      sendData.isSendMail = false;
      sendData.pdfNameForPrint = "尋保圖(個人總覽).pdf";
      // 若為webview開啟則不開新視窗
      let newWindow = this.isWebView() ? window : this.openNewWindow();
      getPDFFile(this.agidno, sendData).then((result) => {
        if (!(result.file && result.file.length > 0)) {
          if (!this.isWebView()) {
            newWindow.close();
          }
          this.panelClose("mvMaskOpen");
          setTimeout(() => alert("報表查無資料"));
          return;
        }
        this.fileNo = result.fileNo;
        setTimeout(() => {
          let fileName =
            this.$store.state.userItems["name"] + "(尋寶)" + result.fileName;
          let file = new Blob([new Uint8Array(result.file)], {
            type: "application/pdf",
          });
          this.sendPdfDataToApp(file, fileName);
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file, fileName);
          } else {
            if (this.isDownload) {
              this.chromeDonloadFile(file, fileName, newWindow);
            } else {
              if (this.isWebView()) {
                newWindow.location = URL.createObjectURL(file);
              } else {
                newWindow.location = `${this.API_BASEURL}/servlet/HttpDispatcher/DOWNLOAD_FILE_API2/download?fileNo=${this.fileNo}`;
              }
            }
          }
          this.panelClose("mvMaskOpen");
        }, 1000);
      });
    },
    openEmail() {
      let chkNoPDFPrint = false;
      for (let i = 0; i < this.familyInfoList.length; i++) {
        let theadAll = this.familyInfoList[i].theadAll;
        if (theadAll) {
          chkNoPDFPrint = true;
        }
      }
      if (!chkNoPDFPrint) {
        this.$toast.info({ title: "請先勾選報表" });
        return false;
      }
      if (!this.checkPDF()) return;
      this.panelOpen("sendEmailModalOpen");
    },
    doSendEmail(form) {
      this.panelOpen("mvMaskOpen");
      let sendData = this.getSendData();
      sendData.subject = form.subject;
      sendData.senderName = form.senderName;
      sendData.sender = form.sender + "@cathaylife.com.tw";
      sendData.receiver = form.receiver;
      sendData.receivercc = form.receivercc;
      sendData.receiverbcc = form.receiverbcc;
      sendData.isSendMail = true;
      sendData.pdfNameForPrint = "尋保圖(個人總覽).pdf";

      getPDFFileForMail(this.agidno, sendData).then((result) => {
        if (result.header && result.header.status === "200") {
          this.$toast.info({ title: "發送成功" });
        } else {
          this.$toast.info({ title: "發送失敗" });
        }
        this.panelClose("mvMaskOpen");
      });
    },
    getSendData() {
      let familyInfoList = [];

      this.familyInfoListDrag.forEach((dragItems) => {
        let familyInfoListObj = {};
        familyInfoListObj["reportType"] = dragItems.reportType;
        familyInfoListObj["cslist"] = [];
        familyInfoListObj["cslistName"] = [];
        dragItems.familyResultFilter.map((familyItems) => {
          if (familyItems.check) {
            familyInfoListObj.cslist.push(familyItems.csidno);
            familyInfoListObj.cslistName.push(familyItems.name);
            return familyItems.csidno;
          }
        });
        familyInfoList.push(familyInfoListObj);
      });

      // familyInfoList["agidno"] = this.agidno;
      // familyInfoList["familyid"] = this.$store.state.userItems.csidno;
      // familyInfoList["isIndigenous"] = this.isIndigenous;
      // familyInfoList["agentInfo"] = [
      //   {
      //     AGENTINFONAME: "AGENT01",
      //     AGENTINFOMOBILE: "0912345678",
      //     REPORTSERIALNUMBER: `${this.generateSerial()}-${this.generateSerial()}`,
      //     AGIDNO: this.agidno
      //   }
      // ];
      let cslistAll = this.familyInfoList[0].familyResultFilter.map(
        (familyItems) => {
          return familyItems.csidno;
        }
      );
      let cslistAllName = this.familyInfoList[0].familyResultFilter.map(
        (familyItems) => {
          return familyItems.name;
        }
      );
      if (this.isCover === "Y") {
        familyInfoList.unshift({
          reportType: "C9",
          cslist: cslistAll,
          cslistName: cslistAllName,
        });
      }
      // array1.unshift
      let sendData = {
        cslistAll: cslistAll,
        familyInfoList: familyInfoList,
        agidno: this.agidno,
        familyid: this.$store.state.userItems.csidno,
        familyName: this.$store.state.userItems.name,
        isIndigenous: this.isIndigenous,
        agentInfo: [
          {
            AGENTINFONAME: this.agentName,
            AGENTINFOMOBILE: this.agentMobile,
            //REPORTSERIALNUMBER: `${this.generateSerial()}-${this.generateSerial()}`,
            AGIDNO: this.agidno,
          },
        ],
      };
      return sendData;
    },
    sortDragItem() {
      if (this.familyInfoListDrag.length > 0) {
        this.familyInfoListDrag.sort(function (a, b) {
          return a.reportType - b.reportType;
        });
      }
    },
    familyInfoListDragInclude(title, isSplice) {
      for (let i = 0; i < this.familyInfoListDrag.length; i++) {
        if (this.familyInfoListDrag[i].reportTitle == title) {
          if (isSplice === "Y") {
            this.familyInfoListDrag.splice(i, 1);
          }
          return true;
        }
      }
      return false;
    },
    checkMove: function (e) {
      // console.log("Future index: " + e.draggedContext.futureIndex);
    },
    changeInput(item) {
      if (this.detectIEEdge() === 11) {
        item.familyResultFilter.forEach(
          (element) => (element.check = item.theadAll)
        );
      } else {
        item.familyResultFilter.forEach(
          (element) => (element.check = !item.theadAll)
        );
      }
    },
    changeInputTF(item, type) {
      if (this.detectIEEdge() === 11) {
        item.familyResultFilter.forEach((element) => (element.check = type));
        if (
          item.familyResultFilter.filter(function (value) {
            return value.check === true;
          }).length == 0
        ) {
          //20220210 調整為不因為成員全無勾選而收闔
          // item.theadAll = false;
        }
      } else {
        item.familyResultFilter.forEach((element) => (element.check = type));
        if (
          item.familyResultFilter.filter(function (value) {
            return value.check === true;
          }).length == 0
        ) {
          //20220210 調整為不因為成員全無勾選而收闔
          // item.theadAll = false;
        }
      }
    },
    checkNonSelected(item, indexI) {
      //20220210 調整為不因為成員全無勾選而收闔
      // item.familyResultFilter[indexI].check = !item.familyResultFilter[indexI].check;
      // if(item.familyResultFilter.filter(function(value) {return value.check === true;}).length == 0){
      //   item.theadAll = false;
      // }
    },
    detectIEEdge() {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf("MSIE ");
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
      }

      var trident = ua.indexOf("Trident/");
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf("rv:");
        return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
      }

      var edge = ua.indexOf("Edge/");
      if (edge > 0) {
        // Edge => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
      }

      // other browser
      return false;
    },
    formatDate(preDate) {
      if (preDate) {
        let dd = moment(preDate).format("YYYY-MM-DD").split("-");
        dd[0] = dd[0] - 1911;
        dd = dd.join("/");

        return dd;
      } else {
        return "";
      }
    },
    changeReportTitle(reportType) {
      if (reportType === "90") {
        return "尋保攻略(當年度權益與保障期間)";
      } else if (reportType === "91") {
        return "尋保地圖(當年保障視圖)";
      } else if (reportType === "92") {
        return "尋保任務(要保人逐月保費彙整)";
      } else if (reportType === "93") {
        return "未來尋保箱(願景藍圖)";
      }
    },
    generateSerial() {
      var chars =
          "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
        serialLength = 10,
        randomSerial = "",
        i,
        randomNumber;

      for (i = 0; i < serialLength; i = i + 1) {
        randomNumber = Math.floor(Math.random() * chars.length);
        randomSerial += chars.substring(randomNumber, randomNumber + 1);
      }
      return randomSerial;
    },
    getAgentData() {
      this.loading_1 = true;
      getAgntInfo(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id
      ).then((result) => {
        if (result.header && result.header.status === "200") {
          this.agentName = result.data.agnt_name;
          this.agentMobile = result.data.mobile;
        }
        this.loading_1 = false;
      });
    },
    setAgentData(agentData) {
      this.agentName = agentData.agentNm;
      this.agentMobile = agentData.agentCellPhone;
    },
    handleScroll() {
      // ----滾動顯示/隱藏----
      this.isScroll = true;
      clearTimeout(this.scrolltimeOutProcessId);
      this.scrolltimeOutProcessId = setTimeout(() => {
        this.isScroll = false;
      }, 1000);
      // ----滾動顯示/隱藏----
    },
    initData() {
      this.dragging = false;
      this.enabled = true;
      //是否滾動
      this.isScroll = false;
      //全選
      this.theadAll = false;
      //業務員ID
      this.agidno = this.$store.state.userInfo.id;
      //業務員名字
      this.agentName = "";
      //手機
      this.agentMobile = "";
      //過濾有勾選
      this.familyResultFilter = this.$store.state.familyResultFilter;
      //全部報表
      this.familyInfoList = [];
      //全部報表Drag
      this.familyInfoListDrag = [];
      //是否為原住民
      this.isIndigenous = "N";
      //是否列印封面
      this.isCover = "N";
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.sendEmailModalOpen = false;
      this.editAgentInfoFindInsModalOpen = false;
      this.loading_1 = false;
      this.mvMaskOpen = false;
      //控制外層選取報表
      this.isSelectPdf = false;
      //報表說明開關
      this.mvPdfInfoOpen = false;
      //報表說明標題
      this.pdfModalTitle = "";
      //報表說明種類
      this.pdfModalType = "";
      //要跳focus的位置
      this.focusPosition = "";
    },
    initCommonlyUsedReport() {
      let report = "01"; // 00：家庭保單健檢規劃書 01：尋保圖（個人總覽）02：321+1保藏圖
      getCommonlyUsedReport(this.agidno, report).then((result) => {
        if (result.header && result.header.status == "200" && result.data) {
          let reportList = result.data.map(function (item) {
            return item.report_type;
          });
          this.familyInfoList.forEach((item) => {
            if (reportList.includes(item.reportType)) {
              item.commonlyUsed = true;
            } else {
              item.commonlyUsed = false;
            }
          });
        }
        this.sortCommonlyUsed();
      });
    },
    sortCommonlyUsed() {
      this.familyInfoList.sort(function (a, b) {
        return a.reportType - b.reportType;
      });
      this.familyInfoList.sort(function (a, b) {
        return a.commonlyUsed && !b.commonlyUsed ? -1 : 1;
      });
      this.$forceUpdate();
    },
    init() {
      window.addEventListener("scroll", this.handleScroll, true);
      //取業務員電話
      this.getAgentData();
      //打開可拖曳
      document.ondragstart = function () {
        return true;
      };
      for (let i = 0; i < 4; i++) {
        let filter = [];
        for (let i = 0; i < this.familyResultFilter.length; i++) {
          filter.push({
            csidno:
              this.familyResultFilter[i].csidno ||
              this.familyResultFilter[i].serNo,
            name: this.familyResultFilter[i].name,
            check: false,
          });
        }

        this.$set(this.familyInfoList, i, {
          isAll: false,
          familyResultFilter: filter,
          reportType: `9${i}`,
          reportTitle: this.changeReportTitle(`9${i}`),
        });
      }

      this.remoteDataMessage =
        "無任何家戶(請先將客戶完成歸戶，才能開始使用保單健檢)";
      // this.initGroupVue();

      // F5 重新整理方案

      // if(this.$store.state.userInfo.id === ''){
      //   setTimeout(() => {
      //     this.initGroupVue()
      //   }, this.$store.state.timeoutVal);
      // }else{
      //   this.initGroupVue()
      // }
      this.initCommonlyUsedReport();
    },
  },
  mounted() {
    this.API_BASEURL = this.getUrl();
    //初始化過後更新刷新參數
    this.$route.meta.reload = false;
    if (
      this.familyResultFilter &&
      this.familyResultFilter.length > 0 &&
      this.$store.state.userItems
    ) {
      localStorage.familyResultFilter = JSON.stringify(this.familyResultFilter);
      localStorage.UserItems = JSON.stringify(this.$store.state.userItems);
      this.init();
    } else {
      new Promise((resolve) => {
        this.updateFamilyResultFilter(
          JSON.parse(localStorage.familyResultFilter)
        );
        this.updateUserItems(JSON.parse(localStorage.UserItems));
        resolve();
      }).then(() => {
        this.familyResultFilter = this.$store.state.familyResultFilter;
        this.init();
      });
    }
  },
  activated() {
    //判斷是否需刷新頁面資料
    if (this.$route.meta.reload) {
      new Promise((resolve) => {
        this.initData();
        resolve();
      }).then(() => {
        this.init();
        this.$route.meta.reload = false;
      });
    } else {
      this.getAgentData();
    }
  },
  filters: {
    //手機格式化(加上'-')
    mobileFormat(srt) {
      if (!srt) {
        return "";
      } else {
        return (
          srt.substring(0, 4) +
          "-" +
          srt.substring(4, 7) +
          "-" +
          srt.substring(7)
        );
      }
    },
  },
  beforeDestroy() {
    //關閉可拖曳
    if (process.env.NODE_ENV !== "development") {
      document.ondragstart = function () {
        return false;
      };
    }
  },
};
</script>
<style scoped>
.pdfTitle {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #027a39;
}
.fit-image {
  width: 100%;
  object-fit: cover;
  /* height: 200px; only if you want fixed height */
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.activeInput {
  background-color: #fdeddc;
  border-radius: 6px;
}
.nactiveInput {
  background-color: rgba(234, 232, 232, 0.877);
  border-radius: 6px;
}
.pt-30 {
  padding-top: 30px;
}
.minHeight-120 {
  min-height: 120vh;
}
.verticalMiddle {
  vertical-align: middle;
}
.w-90 {
  width: 90px;
}

.font-16 {
  font-size: 16px;
}
.font-20 {
  font-size: 20px;
}

.font-24 {
  font-size: 24px;
}
.w-148 {
  width: 148px;
}

.pr-70 {
  padding-right: 70px;
}

.mb-10 {
  margin-bottom: 10px;
}
.mb-15 {
  margin-bottom: 15px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-30 {
  margin-bottom: 30px;
}
.mb-40 {
  margin-bottom: 40px;
}
.mb-60 {
  margin-bottom: 60px;
}

.ml-10 {
  margin-left: 10px;
}
.ml-14 {
  margin-left: 14px;
}
.ml-15 {
  margin-left: 15px;
}
.ml-27 {
  margin-left: 27px;
}

.mr-14 {
  margin-right: 14px;
}
.mr-20 {
  margin-right: 20px;
}

.body-container {
  margin-bottom: 150px;
}
.pdfBtn {
  border-radius: 4px;
  display: table;
  border-radius: 4px;
  background-color: #f5f5f5;
  vertical-align: middle;
  padding: 11px 19px;
  margin: 5px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  font-weight: 600;
}
.pdf-index {
  padding: 11px 5px;
  margin: 5px;
  font-size: 16px;
  text-decoration: none;
  font-weight: 600;
  width: 30px;
}
.pdfDraggableTreasure {
  font-weight: 600;
  position: relative;
  left: -50px;
  font-size: 20px;
}
ol {
  margin-top: 0px;
}

.baseLine {
  vertical-align: baseline !important;
}

.textTop {
  vertical-align: text-top !important;
}

.custModifyAgent {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #027a39;
}

.custAgentTitle {
  margin-right: 15px;
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align-last: right;
  color: #323a45;
}

.custAgentContent {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #323a45;
}

.btn-common:hover {
  color: #ffffff;
  background-color: #9f9f9f;
}

.btn-common {
  margin-left: auto;
  border: none;
  color: #9f9f9f;
  font-weight: 700;
}

.btn-common:hover {
  color: #ffffff;
  background-color: #9f9f9f;
}

.btn-common-active {
  margin-left: auto;
  border: none;
  color: #f58818;
  font-weight: 700;
  background-color: #f5dec5;
  -webkit-transition: background-color 500ms linear;
  -ms-transition: background-color 500ms linear;
  transition: background-color 500ms linear;
}

.btn-common-active:hover {
  color: #ffffff;
  background-color: #ffb465;
}
</style>